__turbopack_context__.v({
  "container": "Spinner-module-scss-module__rrhiKG__container",
  "line-break": "Spinner-module-scss-module__rrhiKG__line-break",
  "text-align_center": "Spinner-module-scss-module__rrhiKG__text-align_center",
});
